module.exports = __webpack_public_path__ + "static/media/BONE.f919a3ce.png";